import * as React from 'react';
import { PlusIcon } from 'components/SVG';
import { SparkButton } from 'sharedComponents/UI';
import { useResize } from 'hooks/common';
import Grid from '@mui/material/Grid';
import { useGetTags } from 'hooks/SparkBuilder/pluginFunction/pluginConnectionsAndParameters/useTags';
import { Box } from '@mui/material';
import { SwitcherButton } from 'sharedComponents/UI/SparkSwitcher';

type PluginToggleProps = {
  setSelectedTag: (tag: string) => void;
  selectedTag: string;
};

const PluginToggle = ({ setSelectedTag, selectedTag }: PluginToggleProps) => {
  const { isMobile } = useResize();
  const { tags } = useGetTags();

  const filteredTags = React.useMemo(() => {
    if (!tags) return [];

    const allTag = {
      id: 'all',
      attributes: {
        name: 'All',
      },
    };

    return [allTag, ...tags];
  }, [tags]);

  // Automatically select "All" once tags are loaded
  React.useEffect(() => {
    if (!selectedTag && filteredTags.length > 0) {
      setSelectedTag('all');
    }
  }, [filteredTags, selectedTag, setSelectedTag]);

  return (
    <Grid
      container
      alignItems='center'
      justifyContent='space-between'
      marginLeft={isMobile ? 0 : 2}
    >
      <Grid container item xs={isMobile ? 12 : 'auto'} minWidth='50%'>
        <Box
          width='100%'
          display='flex'
          height='3rem'
          justifyContent='space-between'
          alignItems='center'
          padding='2px'
          overflow='hidden'
          sx={{
            borderRadius: 50,
            borderWidth: '1px',
            borderStyle: 'solid',
            borderColor: (theme) => theme.palette.borderColor,
          }}
        >
          {filteredTags.map((tag) => (
            <SwitcherButton
              key={tag.id} // ✅ Add key here!
              title={tag.attributes.name}
              value={tag.id}
              selected={selectedTag === tag.id}
              handleValueChange={setSelectedTag}
            />
          ))}
        </Box>
      </Grid>

      <Grid item xs={isMobile ? 12 : 4}>
        <Grid
          container
          justifyContent={isMobile ? 'center' : 'flex-end'}
          style={{ width: '100%' }}
        >
          <SparkButton
            style={{ padding: '10px 20px', marginRight: '10px' }}
            startIcon={<PlusIcon color='white' />}
            variant='contained'
            onClick={() => {}}
          >
            Request Plugin
          </SparkButton>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default PluginToggle;
